export class ContactForm {
    constructor(formSelector , successSelector, failSelector, url) {
        if (!formSelector) {
            console.error(
                `ContactForm requires a form selector`
            );

            return;
        }

        if (!url) {
            console.error(
                `ContactForm requires a url`
            );

            return;
        }

        if (!successSelector) {
            console.error(
                `ContactForm requires a success selector`
            );
        }

        if (!failSelector) {
            console.error(
                `ContactForm requires a fail selector`
            );
        }

        this.formSelector = formSelector;
        this.url = url;
        this.successSelector = successSelector;
        this.failSelector = failSelector;
    }

    init() {
        this.form = document.getElementById(this.formSelector);
        if (!this.form) {
            console.error(
                `Could not find form with selector ${this.formSelector}`
            );

            return;
        }

        const success = document.getElementById(this.successSelector);
        if (!success) {
            console.error(
                `Could not find success selector ${this.successSelector}`
            );
        }

        const fail = document.getElementById(this.failSelector);
        if (!fail) {
            console.error(
                `Could not find fail selector ${this.failSelector}`
            );
        }

        const elements = this.form.elements;

        const resetErrors = () => {
            for (let i = 0; i < elements.length; i++) {
                const name = elements[i].name;

                elements[i].classList.remove('border-danger');

                if (!name) {
                    continue;
                }

                const elementError = document.getElementById(name + '_error');
                if (!elementError) {
                    continue;
                }

                elementError.classList.remove('d-block');
                elementError.textContent = '';
            }
        };

        const setElementsDisabled = (disabled) => {
            for (let i = 0; i < elements.length; i++) {
                elements[i].disabled = disabled;
            }
        };

        const showFailMessage = (message) => {
            fail.textContent = message || 'Что-то пошло не так. Попробуйте позже.';
            fail.classList.remove('d-none');
        };

        const showValidationErrors = (data = {}) => {
            const errors = data.errors || {};
            const messages = [];

            for (const [name, error] of Object.entries(errors)) {
                const message = Array.isArray(error) ? (error[0] || '') : String(error || '');
                if (!message) {
                    continue;
                }

                messages.push(message);

                const element = document.getElementById(name);
                const elementError = document.getElementById(name + '_error');

                if (!element || !elementError) {
                    continue;
                }

                elementError.textContent = message;
                elementError.classList.add('d-block');
                element.classList.add('border-danger');
            }

            showFailMessage(messages.length ? messages.join(' ') : data.message);
        };

        this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            const data = new FormData(event.target);

            setElementsDisabled(true);
            resetErrors();
            success.classList.add('d-none');
            fail.classList.add('d-none');

            fetch(this.url, {
                method: 'POST',
                body: data,
                headers: {
                    'Accept': 'application/json'
                }
            }).then(response => {
                if (response.ok) {
                    if (typeof ym === 'function') {
                        ym(45700734,'reachGoal','send_contact');
                    }

                    this.form.reset();
                    success.classList.remove('d-none');

                    return;
                }

                return response.json()
                    .then(data => showValidationErrors(data))
                    .catch(() => showFailMessage('Не удалось отправить заявку. Попробуйте позже.'));
            }).catch(error => {
                console.error(error);
                showFailMessage('Не удалось отправить заявку. Проверьте соединение и попробуйте ещё раз.');
            }).finally(() => {
                setElementsDisabled(false);
            });
        });
    }
}
